<template>

  <section class="dp-layout">
    <section class="dp-left">
      <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
    </section>

    <section class="dp-right">
      <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>
      <div style="margin: 0 0 10px 0;">
        <el-button size="small" type="primary" plain @click="openGroupManage">维护专项分组</el-button>
        <el-button size="small" type="primary" plain @click="openAdminManage">专项账号管理员</el-button>
      </div>

      <div class="tbl-scroll-host">
      <el-table :data="users" v-loading="listLoading" @select="dialogCheck" @row-click="selectCurrentRow" ref="table"
        class="custom-tbl" height="100%" style="width: 100%">
        <el-table-column type="selection" width="50"> </el-table-column>

        <el-table-column prop="StuName" label="学生姓名" width="">
        </el-table-column>
        <el-table-column prop="DepartmentName" label="部门" width="">
          <template slot-scope="scope">
            {{ formatDepartmentShort(scope.row.DepartmentName) }}
          </template>
        </el-table-column>

        <el-table-column prop="SubsidyTypeName" label="补贴类型" width="">
        </el-table-column>
        <el-table-column prop="SubsidyGroupName" label="专项分组" width="">
          <template slot-scope="scope">
            <span>{{ scope.row.SubsidyGroupName || '—' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="SubsidyBalance" label="专项余额" width="">
        </el-table-column>
        <el-table-column prop="TodaySubsidyConsumedAmount" label="日消费" width="">
          <template slot-scope="scope">
            {{ formatSubsidyMoney(scope.row.TodaySubsidyConsumedAmount) }}
          </template>
        </el-table-column>
        <el-table-column prop="DailyMaxConsumption" label="日消费上限" width="150">
          <template slot-scope="scope">
            <span>{{ formatSubsidyEffectiveDaily(scope.row) }}</span>
            <el-tag v-if="subsidyRowUsesGroupLimit(scope.row)" type="info" size="mini" style="margin-left:4px;">随分组</el-tag>
          </template>
        </el-table-column>

        <el-table-column prop="Status" label="状态" width="88">
          <template slot-scope="scope">
            <el-tag :type="scope.row.Status == 1 ? 'success' : 'info'" size="mini" disable-transitions>
              {{ scope.row.Status == 1 ? '已启用' : '未启用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="CreateTime" label="创建时间" :formatter="formatCreateTime" width></el-table-column>

        <el-table-column label="操作" width="200" align="center">
          <template slot-scope="scope">
            <div class="table-op-pair">
              <el-button type="text" class="table-op-link" @click.stop="openSubsidyHistory(scope.row)">专项明细</el-button>
              <el-tooltip :disabled="scope.row.Status == 1"
                content="请先点击「启用」并确认；状态列为「已启用」后即可手动充扣专项余额。" placement="top">
                <span class="subsidy-stu-ops-tip-wrap">
                  <el-button type="text" class="table-op-link" @click.stop="openRecharge(scope.row)"
                    :disabled="scope.row.Status != 1">手动充扣</el-button>
                </span>
              </el-tooltip>
              <el-button type="text" class="table-op-link" @click.stop="openSettings(scope.row)">编辑设置</el-button>
              <el-button v-if="scope.row.Status != 1" type="text" class="table-op-link admin-op-enable"
                @click.stop="confirmSubsidyStudentStatus(scope.row, 1)">启用</el-button>
              <el-button v-else type="text" class="table-op-link table-op-link--danger admin-op-danger"
                @click.stop="confirmSubsidyStudentStatus(scope.row, 0)">停用</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      </div>

      <el-col :span="24" class="toolbar">
        <el-pagination layout="total, prev, pager, next, jumper" @current-change="handleCurrentChange" :page-size="50"
          :total="total" style="float: right">
        </el-pagination>
      </el-col>

      <el-dialog title="新增补贴用户信息" :visible.sync="addFormVisible" v-model="addFormVisible" :close-on-click-modal="false">
        <el-form :model="addForm" label-width="100px" :rules="addFormRules" ref="addForm" class="demo-form-inline">



          <!-- 人员：家校通讯录多选。最后更新：2026-09-23 -->
          <el-form-item label="人员" required>
            <div class="ps-pick-summary">
              <span v-if="personSelectedItems.length">已选 <strong>{{ personSelectedItems.length }}</strong> 人
                <template v-if="personSelectedDeptCount">（{{ personSelectedDeptCount }} 个部门）</template>
              </span>
              <span v-else class="muted-text">请从家校通讯录选择学生</span>
              <el-button type="primary" size="small" plain @click="openPersonPicker">选择学生</el-button>
              <el-button v-if="personSelectedItems.length" type="text" size="small" @click="clearPersonSelection">清空</el-button>
            </div>
            <div v-if="personSelectedItems.length" class="ps-pick-tags">
              <el-tag
                v-for="item in personSelectedPreview"
                :key="item.id"
                size="mini"
                closable
                disable-transitions
                @close="removePersonSelected(item.id)">
                {{ item.name }}
              </el-tag>
              <span v-if="personSelectedItems.length > 8" class="ps-pick-more">等 {{ personSelectedItems.length }} 人</span>
            </div>
          </el-form-item>

          <el-form-item label="专项分组">
            <el-select v-model="addForm.subsidyGroupId" clearable placeholder="可选，用于默认每日消费上限" style="width:100%"
              @change="onAddFormGroupChange">
              <el-option v-for="g in groupOptions" :key="g.Id"
                :label="g.GroupName + (g.DailyMaxConsumption > 0 ? '（默认日限额' + g.DailyMaxConsumption + '）' : '（默认不限）')"
                :value="g.Id" />
            </el-select>
          </el-form-item>
          <el-form-item label="使用分组限额">
            <el-switch v-model="addForm.useGroupDailyLimit" :disabled="!addForm.subsidyGroupId"
              active-text="是" inactive-text="否" @change="onAddFormUseGroupSwitch" />
            <div style="color:#909399;font-size:12px;margin-top:4px;">为「是」时每日上限随专项分组维护中的默认日限额变化，无需逐人修改；无分组时不可选</div>
          </el-form-item>
          <el-form-item v-if="!addForm.useGroupDailyLimit" label="每日消费上限">
            <el-input v-model="addForm.dailyMaxConsumptionText" clearable placeholder="留空表示不限制；填写数字为本人固定上限" />
            <div style="color:#909399;font-size:12px;margin-top:4px;">与分组限额解绑，改分组不会影响此处</div>
          </el-form-item>

          <el-form-item label="备注">
            <el-input type="textarea" v-model="addForm.Remarks"></el-input>
          </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="addFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
        </div>
      </el-dialog>

      <!-- 新增选人：仅学生（家校通讯录多选）。创建于 2026-09-23 -->
      <person-scope-multi-picker-dialog
        :visible.sync="personPickerVisible"
        directory-scope="teaching"
        :show-scope-tabs="false"
        :scope-department-id="DepartmentId"
        title="选择学生"
        :value="personSelectedItems"
        @confirm="onPersonsPicked"
      />

      <el-dialog title="编辑专项设置" :visible.sync="settingsVisible" width="520px" :close-on-click-modal="false">
        <el-form :model="settingsForm" label-width="140px" v-if="settingsVisible">
          <el-form-item label="专项分组">
            <el-select v-model="settingsForm.subsidyGroupId" clearable placeholder="不选则无分组" style="width:100%"
              @change="onSettingsGroupChange">
              <el-option v-for="g in groupOptions" :key="g.Id"
                :label="g.GroupName + (g.DailyMaxConsumption > 0 ? '（默认日限额' + g.DailyMaxConsumption + '）' : '')"
                :value="g.Id" />
            </el-select>
          </el-form-item>
          <el-form-item label="使用分组限额">
            <el-switch v-model="settingsForm.useGroupDailyLimit" :disabled="!settingsForm.subsidyGroupId"
              active-text="是" inactive-text="否" @change="onSettingsUseGroupSwitch" />
            <div style="color:#909399;font-size:12px;margin-top:4px;">为「是」时以分组默认日限额为准，维护分组即可统一调整</div>
          </el-form-item>
          <el-form-item v-if="!settingsForm.useGroupDailyLimit" label="每日最高消费金额">
            <el-input-number v-model="settingsForm.dailyMaxConsumption" :min="0" :precision="2" style="width:100%" />
            <div style="color:#909399;font-size:12px;margin-top:4px;">0 表示不限制（本人固定上限，与分组解绑）</div>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="settingsVisible = false">取消</el-button>
          <el-button type="primary" :loading="settingsLoading" @click="saveSettings">保存</el-button>
        </div>
      </el-dialog>

      <el-dialog title="专项余额变动明细" :visible.sync="subsidyHistoryVisible" width="45%" center
        @close="subsidyHistoryClose">
        <el-table :data="subsidyHistoryData" class="custom-tbl" style="width: 100%">
          <el-table-column property="BalanceBeforeChange" label="变动前余额"></el-table-column>
          <el-table-column prop="ChangeAmount" label="变动金额" width="120">
            <template slot-scope="scope">
              <span v-if="scope.row.Type == 1" style="color:orange;">+ {{ scope.row.ChangeAmount }}</span>
              <span v-else>- {{ scope.row.ChangeAmount }}</span>
            </template>
          </el-table-column>
          <el-table-column property="BalanceAfterChange" label="变动后余额"></el-table-column>
          <el-table-column property="ChangeReason" label="说明" width="120"></el-table-column>
          <el-table-column property="CreateTime" label="时间" width="160"></el-table-column>
        </el-table>
        <el-col :span="24" class="toolbar">
          <el-pagination layout="total, prev, pager, next, jumper" @current-change="subsidyHistoryPageChange"
            :page-size="10" :total="subsidyHistoryTotal" :current-page="subsidyHistoryPage" style="float: right">
          </el-pagination>
        </el-col>
        <div slot="footer" class="dialog-footer">
          <el-button @click="subsidyHistoryVisible = false">关 闭</el-button>
        </div>
      </el-dialog>

      <el-dialog :title="subsidyManualReverseEnabled ? '专项余额：手动充值 / 扣除 / 冲正' : '专项余额：手动充值 / 扣除'"
        :visible.sync="rechargeDialogVisible" width="440px" :close-on-click-modal="false">
        <el-form>
          <el-form-item label="操作类型" label-width="90px">
            <el-radio-group v-model="rechargeType">
              <el-radio label="1">手动充值</el-radio>
              <el-radio label="2">手动扣除</el-radio>
              <el-radio v-if="subsidyManualReverseEnabled" label="3">冲正</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="金额" label-width="90px" v-if="rechargeType !== '3'">
            <el-input v-model="rechargeAmount" placeholder="请输入金额" type="number" min="0.01" />
          </el-form-item>
          <el-form-item v-if="subsidyManualReverseEnabled && rechargeType === '3'" label="冲正记录">
            <el-select v-model="selectedReverseId" placeholder="请选择要冲正的专项手动充值" style="width:100%;">
              <el-option v-for="item in subsidyManualRechargeList" :key="item.Id"
                :label="`${item.ChangeAmount} 元 - ${item.CreateTime}`" :value="item.Id" />
            </el-select>
            <el-pagination style="margin-top:10px;text-align:right" layout="total,prev, pager, next" small
              :page-size="subsidyManualPageSize" :total="subsidyManualTotal" :current-page="subsidyManualPage"
              @current-change="fetchSubsidyManualList" />
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="rechargeDialogVisible = false">取 消</el-button>
          <el-button type="primary" :loading="rechargeLoading" @click="confirmSubsidyRecharge">确 定</el-button>
        </div>
      </el-dialog>

      <el-dialog title="维护专项分组" :visible.sync="groupManageVisible" width="550px" :close-on-click-modal="false">
        <div style="display:flex;flex-wrap:wrap;align-items:center;gap:8px;">
          <el-input v-model="newGroupName" placeholder="新分组名称" style="width:180px;" />
          <span style="font-size:13px;color:#606266;">默认日限额</span>
          <el-input-number v-model="newGroupDailyMax" :min="0" :precision="2" size="small" style="width:140px;" />
          <el-button type="primary" size="small" @click="addGroup" :disabled="!DepartmentId">添加</el-button>
        </div>
        <el-table :data="groupManagePagedList" style="width:100%;margin-top:12px;" size="small">
          <el-table-column prop="GroupName" label="名称" width="" />
          <el-table-column prop="DailyMaxConsumption" label="默认日限额" width="">
            <template slot-scope="scope">
              {{ scope.row.DailyMaxConsumption > 0 ? scope.row.DailyMaxConsumption : '不限制' }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="200" align="center">
            <template slot-scope="scope">
              <div class="table-op-pair">
                <el-button type="text" class="table-op-link" @click="openGroupEdit(scope.row)">编辑</el-button>
                <el-button type="text" class="table-op-link table-op-link--danger admin-op-danger" @click="removeGroup(scope.row)">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-col :span="24" class="toolbar" style="margin-top:10px;">
          <el-pagination layout="total, prev, pager, next, jumper" @current-change="groupManagePageChange"
            :page-size="groupManagePageSize" :total="groupManageList.length" :current-page="groupManagePage"
            style="float: right">
          </el-pagination>
        </el-col>
        <div slot="footer" class="dialog-footer">
          <el-button @click="groupManageVisible = false">关 闭</el-button>
        </div>
      </el-dialog>

      <el-dialog title="编辑专项分组" :visible.sync="groupEditVisible" width="480px" :close-on-click-modal="false"
        append-to-body>
        <el-form :model="groupEditForm" label-width="110px" v-if="groupEditVisible">
          <el-form-item label="分组名称">
            <el-input v-model="groupEditForm.groupName" maxlength="100" show-word-limit />
          </el-form-item>
          <el-form-item label="默认日限额">
            <el-input-number v-model="groupEditForm.dailyMaxConsumption" :min="0" :precision="2" style="width:100%" />
            <div style="color:#909399;font-size:12px;margin-top:4px;">0 表示不限制</div>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="groupEditVisible = false">取消</el-button>
          <el-button type="primary" :loading="groupEditLoading" @click="saveGroupEdit">保存</el-button>
        </div>
      </el-dialog>

      <el-dialog
        title="专项账号管理员"
        custom-class="subsidy-admin-dialog"
        :visible.sync="adminManageVisible"
        width="640px"
        :close-on-click-modal="false">
        <div class="admin-toolbar">
          <span class="admin-toolbar__label">选择教师</span>
          <div class="admin-toolbar__pick">
            <div class="ps-pick-summary">
              <span v-if="adminPickTeacherId">已选 <strong>{{ adminPickTeacherLabel || ('教职工#' + adminPickTeacherId) }}</strong></span>
              <span v-else class="muted-text">请选择一名教职工</span>
              <el-button type="primary" size="small" plain :disabled="!DepartmentId" @click="openAdminTeacherPicker">选择教职工</el-button>
              <el-button v-if="adminPickTeacherId" type="text" size="small" @click="clearAdminTeacherPick">清空</el-button>
            </div>
          </div>
          <el-button
            type="primary"
            size="small"
            :disabled="!adminPickTeacherId || !DepartmentId"
            @click="submitAdminAdd">添加</el-button>
        </div>
        <el-table :data="adminList" size="small" class="admin-table" style="width: 100%">
          <el-table-column label="教师" min-width="160" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.TeacherName || scope.row.Name || '—' }}
            </template>
          </el-table-column>
          <el-table-column label="启用" width="90" align="center">
            <template slot-scope="scope">
              <el-tag :type="scope.row.Enabled ? 'success' : 'info'" size="mini" disable-transitions>
                {{ scope.row.Enabled ? '是' : '否' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="200" align="center">
            <template slot-scope="scope">
              <div class="table-op-pair">
                <el-button v-if="!scope.row.Enabled" type="text" class="table-op-link admin-op-enable"
                  @click="toggleAdmin(scope.row)">启用</el-button>
                <el-button v-else type="text" class="table-op-link table-op-link--danger admin-op-danger" @click="toggleAdmin(scope.row)">停用</el-button>
                <el-button type="text" class="table-op-link table-op-link--danger admin-op-danger" @click="removeAdmin(scope.row)">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="admin-pager">
          <el-pagination
            layout="total, prev, pager, next, jumper"
            :page-size="adminPageSize"
            :total="adminTotal"
            :current-page="adminPage"
            @current-change="adminPageChange" />
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="adminManageVisible = false">关闭</el-button>
        </div>
      </el-dialog>

      <person-scope-picker-dialog
        :visible.sync="adminTeacherPickerVisible"
        directory-scope="internal"
        :show-scope-tabs="false"
        :scope-department-id="DepartmentId"
        :value="adminPickTeacherId"
        :label="adminPickTeacherLabel"
        title="选择专项账号管理员"
        @confirm="onAdminTeacherPicked"
      />

    </section>

  </section>

</template>

<script>
import util from "../../../util/date";
import { getSubsidyStudentListPage, addSubsidyStudent, deleteSubsidyStudent, putSubsidyStudentSettings, putSubsidyStudentStatus, manualSubsidyBalance, getSubsidyAccountChange, getSubsidyManualRechargeList, getSubsidyStudentGroupList, addSubsidyStudentGroup, editSubsidyStudentGroup, deleteSubsidyStudentGroup, getSubsidyAccountAdminListPage, addSubsidyAccountAdmin, editSubsidyAccountAdmin, deleteSubsidyAccountAdmin } from '../../api/modules/consumption';
import { BaseApiUrl } from '../../api/base';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import DepartmentPane from '../../components/DepartmentPane'
import PersonScopeMultiPickerDialog from '../../components/PersonScopeMultiPickerDialog'
import PersonScopePickerDialog from '../../components/PersonScopePickerDialog'

export default {
  components: { Toolbar, DepartmentPane, PersonScopeMultiPickerDialog, PersonScopePickerDialog },
  data() {
    return {
      filters: {
      },
      BaseApiUrl: BaseApiUrl,
      searchList: [
        {
          label: '消费日期',
          key: 'usageStatDate',
          type: 'date',
          width: '160px',
        },
        {
          label: '名称',
          key: 'name',
        },
      ],
      users: [],
      total: 0,
      buttonList: [],
      currentRow: null,
      page: 1,
      listLoading: false,
      options: [],
      addFormVisible: false,
      addLoading: false,
      addFormRules: {
      },
      addForm: {
        Remarks: "",
        DepartmentId: 0,
        UserIds: []
      },
      /** 新增弹窗已选学生（通讯录多选）。创建于 2026-09-23 */
      personSelectedItems: [],
      personPickerVisible: false,
      isResouceShow: 0,
      DepartmentId: 0,
      groupOptions: [],
      settingsVisible: false,
      settingsLoading: false,
      settingsForm: {
        id: 0,
        subsidyGroupId: null,
        useGroupDailyLimit: false,
        dailyMaxConsumption: 0,
      },
      groupEditVisible: false,
      groupEditLoading: false,
      groupEditForm: {
        id: 0,
        groupName: '',
        dailyMaxConsumption: 0,
        sort: 0,
      },
      subsidyHistoryVisible: false,
      subsidyHistoryData: [],
      subsidyHistoryTotal: 0,
      subsidyHistoryPage: 1,
      subsidyHistoryUserId: 0,
      rechargeDialogVisible: false,
      rechargeAmount: '',
      rechargeLoading: false,
      rechargeRow: null,
      rechargeType: '1',
      /** 为 true 时显示「冲正」及冲正记录（暂不开放时保持 false） */
      subsidyManualReverseEnabled: false,
      subsidyManualRechargeList: [],
      selectedReverseId: '',
      subsidyManualPage: 1,
      subsidyManualTotal: 0,
      subsidyManualPageSize: 10,
      groupManageVisible: false,
      groupManageList: [],
      groupManagePage: 1,
      groupManagePageSize: 5,
      newGroupName: '',
      newGroupDailyMax: 0,
      adminManageVisible: false,
      adminList: [],
      adminTotal: 0,
      adminPage: 1,
      adminPageSize: 5,
      adminPickTeacherId: null,
      adminPickTeacherLabel: '',
      adminTeacherPickerVisible: false,
    };
  },
  computed: {
    groupManagePagedList() {
      const list = this.groupManageList || [];
      const start = (this.groupManagePage - 1) * this.groupManagePageSize;
      return list.slice(start, start + this.groupManagePageSize);
    },
    personSelectedPreview() {
      return (this.personSelectedItems || []).slice(0, 8);
    },
    personSelectedDeptCount() {
      const set = {};
      (this.personSelectedItems || []).forEach((item) => {
        if (item && item.deptId != null && item.deptId !== '')
          set[String(item.deptId)] = true;
      });
      return Object.keys(set).length;
    },
  },
  methods: {
    groupManagePageChange(page) {
      this.groupManagePage = page;
    },
    async loadGroupOptions() {
      if (!this.DepartmentId) {
        this.groupOptions = [];
        return;
      }
      const res = await getSubsidyStudentGroupList({ departmentId: this.DepartmentId });
      if (res.data && res.data.success)
        this.groupOptions = res.data.response || [];
    },
    onAddFormUseGroupSwitch(on) {
      if (on)
        this.addForm.dailyMaxConsumptionText = '';
    },
    onSettingsUseGroupSwitch(on) {
      if (on && this.settingsForm.subsidyGroupId)
        this.onSettingsGroupChange(this.settingsForm.subsidyGroupId);
    },
    onAddFormGroupChange(groupId) {
      if (!groupId) {
        this.addForm.dailyMaxConsumptionText = '';
        this.addForm.useGroupDailyLimit = false;
        return;
      }
      if (this.addForm.useGroupDailyLimit) {
        this.addForm.dailyMaxConsumptionText = '';
        return;
      }
      const g = this.groupOptions.find(x => x.Id === groupId);
      if (g && g.DailyMaxConsumption != null && Number(g.DailyMaxConsumption) > 0)
        this.addForm.dailyMaxConsumptionText = String(g.DailyMaxConsumption);
      else
        this.addForm.dailyMaxConsumptionText = '';
    },
    onSettingsGroupChange(groupId) {
      if (!groupId) {
        this.settingsForm.useGroupDailyLimit = false;
        return;
      }
      if (this.settingsForm.useGroupDailyLimit) {
        const g = this.groupOptions.find(x => x.Id === groupId);
        if (g && g.DailyMaxConsumption != null)
          this.settingsForm.dailyMaxConsumption = Number(g.DailyMaxConsumption);
        return;
      }
      const g = this.groupOptions.find(x => x.Id === groupId);
      if (g && g.DailyMaxConsumption != null)
        this.settingsForm.dailyMaxConsumption = Number(g.DailyMaxConsumption);
    },
    subsidyRowUsesGroupLimit(row) {
      return row && (row.UseGroupDailyLimit === true || row.UseGroupDailyLimit === 1) && !!row.SubsidyGroupId;
    },
    formatSubsidyEffectiveDaily(row) {
      if (!row) return '—';
      const e = row.EffectiveDailyMaxConsumption != null && row.EffectiveDailyMaxConsumption !== ''
        ? Number(row.EffectiveDailyMaxConsumption)
        : NaN;
      const v = !isNaN(e) ? e : Number(row.DailyMaxConsumption) || 0;
      return v > 0 ? String(v) : '不限制';
    },
    /** 列表金额两位小数（与专项余额列展示习惯一致） */
    formatSubsidyMoney(val) {
      if (val === null || val === undefined || val === '') return '0.00';
      const n = Number(val);
      return Number.isFinite(n) ? n.toFixed(2) : String(val);
    },

    formatCreateTime: function (row, column) {
      return !row.CreateTime || row.CreateTime == ''
        ? ''
        : util.formatDate.format(
          new Date(row.CreateTime),
          'yyyy-MM-dd hh:mm:ss'
        )
    },
    /** 部门全路径只展示末尾「年级 + 班级」两段（按 / 拆分） */
    formatDepartmentShort(name) {
      if (name == null || name === '') return '—';
      const s = String(name).trim();
      if (!s) return '—';
      const parts = s.split('/').map((x) => x.trim()).filter(Boolean);
      if (parts.length === 0) return '—';
      if (parts.length === 1) return parts[0];
      return parts.slice(-2).join(' ');
    },
    treeNodeClick(data, node, component) {
      this.DepartmentId = data.value
      this.loadGroupOptions();
      this.handleQuery();
    },
    dialogCheck(selection, row) {
      this.currentRow = null;
      this.$refs.table.clearSelection();
      if (selection.length === 0) {
        return;
      }
      if (row) {
        this.selectCurrentRow(row);
      }
    },
    selectCurrentRow(val) {
      if (val) {
        this.currentRow = val;
        this.$refs.table.clearSelection();
        this.$refs.table.toggleRowSelection(val, true);
      }
    },
    callFunction(item) {
      if (typeof item.search == 'object') {
        this.filters = item.search
      } else {
        this.filters = {
          key: item.search,
        }
      }
      this[item.Func].apply(this, item)
    },
    handleCurrentChange(val) {
      this.page = val;
      this.handleQuery();
    },
    handleQuery() {
      let para = {
        departmentId: this.DepartmentId,
        page: this.page,
        intPageSize: 50,
        ...this.filters,
      }
      this.listLoading = true;
      getSubsidyStudentListPage(para).then((res) => {
        this.total = res.data.response.dataCount;
        const rows = res.data.response.data || [];
        rows.forEach((r) => {
          r.Status = r.Status === 1 || r.Status === '1' ? 1 : 0;
          r.UseGroupDailyLimit = r.UseGroupDailyLimit === true || r.UseGroupDailyLimit === 1;
        });
        this.users = rows;
        this.listLoading = false;
      });
    },
    handleDel() {
      let row = this.currentRow;
      this.options = [];
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });
        return;
      }
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          let para = { id: row.Id };
          deleteSubsidyStudent(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
            this.handleQuery();
          });
        })
        .catch(() => { });
    },
    handleAdd() {
      if (!this.DepartmentId || this.DepartmentId === 0) {
        this.$message({
          message: "请先选择左侧所属机构！",
          type: "warning",
        });
        return;
      }
      this.addFormVisible = true;
      this.addForm = {
        Remarks: "",
        DepartmentId: this.DepartmentId,
        UserIds: [],
        subsidyGroupId: null,
        useGroupDailyLimit: true,
        dailyMaxConsumptionText: '',
      };
      this.clearPersonSelection();
      this.loadGroupOptions();
    },
    /** 打开家校通讯录多选。创建于 2026-09-23 */
    openPersonPicker() {
      if (!this.DepartmentId) {
        this.$message.warning('请先在左侧选择部门');
        return;
      }
      this.personPickerVisible = true;
    },
    onPersonsPicked(people) {
      this.personSelectedItems = (people || []).map((p) => ({
        id: String(p.id),
        name: p.name || String(p.id),
        personType: 'student',
        deptId: p.deptId != null ? String(p.deptId) : '0',
        deptLabel: p.deptLabel || '',
      }));
      this.syncUserIdsFromPersonItems();
    },
    clearPersonSelection() {
      this.personSelectedItems = [];
      if (this.addForm) this.addForm.UserIds = [];
    },
    removePersonSelected(id) {
      const key = String(id);
      this.personSelectedItems = (this.personSelectedItems || []).filter((x) => String(x.id) !== key);
      this.syncUserIdsFromPersonItems();
    },
    /** UserIds 形如 [deptId, userId][]，与后端 DiscountSubsidyUserDto 一致 */
    syncUserIdsFromPersonItems() {
      this.addForm.UserIds = (this.personSelectedItems || []).map((item) => [
        String(item.deptId || '0'),
        String(item.id),
      ]);
    },
    addSubmit: function () {
      if (!this.personSelectedItems.length) {
        this.$message({ message: '请先选择人员', type: 'warning' });
        return;
      }
      this.syncUserIdsFromPersonItems();
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;
            let para = Object.assign({}, this.addForm);
            para.SubsidyGroupId = para.subsidyGroupId || null;
            delete para.subsidyGroupId;
            const useGroup = !!para.useGroupDailyLimit && !!para.SubsidyGroupId;
            para.UseGroupDailyLimit = useGroup;
            delete para.useGroupDailyLimit;
            const dailyTxt = (para.dailyMaxConsumptionText || '').trim();
            delete para.dailyMaxConsumptionText;
            if (!useGroup && dailyTxt !== '' && !isNaN(Number(dailyTxt)) && Number(dailyTxt) >= 0)
              para.DailyMaxConsumption = Number(dailyTxt);
            addSubsidyStudent(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.addLoading = false;
                return;
              }
              if (res.data.success) {
                this.addLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["addForm"].resetFields();
                this.clearPersonSelection();
                this.addFormVisible = false;
                this.handleQuery();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
                this.addLoading = false;
              }
            });
          });
        }
      });
    },
    openSettings(row) {
      const useGroup = row.UseGroupDailyLimit === true || row.UseGroupDailyLimit === 1;
      let daily = row.DailyMaxConsumption != null ? Number(row.DailyMaxConsumption) : 0;
      if (useGroup && row.SubsidyGroupId) {
        const g = this.groupOptions.find((x) => x.Id === row.SubsidyGroupId);
        if (g && g.DailyMaxConsumption != null)
          daily = Number(g.DailyMaxConsumption);
      } else if (row.EffectiveDailyMaxConsumption != null && row.EffectiveDailyMaxConsumption !== '') {
        daily = Number(row.EffectiveDailyMaxConsumption);
      }
      this.settingsForm = {
        id: row.Id,
        subsidyGroupId: row.SubsidyGroupId || null,
        useGroupDailyLimit: !!useGroup && !!row.SubsidyGroupId,
        dailyMaxConsumption: daily,
      };
      this.settingsVisible = true;
    },
    saveSettings() {
      this.settingsLoading = true;
      const body = {
        Id: this.settingsForm.id,
        SubsidyGroupId: this.settingsForm.subsidyGroupId,
        UseGroupDailyLimit: !!this.settingsForm.useGroupDailyLimit && !!this.settingsForm.subsidyGroupId,
        DailyMaxConsumption: this.settingsForm.dailyMaxConsumption,
      };
      putSubsidyStudentSettings(body).then((res) => {
        this.settingsLoading = false;
        if (res.data && res.data.success) {
          this.$message.success(res.data.msg || '保存成功');
          this.settingsVisible = false;
          this.handleQuery();
        } else {
          this.$message.error((res.data && res.data.msg) || '保存失败');
        }
      }).catch(() => { this.settingsLoading = false; });
    },
    confirmSubsidyStudentStatus(row, newStatus) {
      const enable = newStatus === 1;
      const msg = enable
        ? '确认启用该学生的专项账号？启用后可正常使用专项余额与手动充扣。'
        : '确认停用该学生的专项账号？停用后将无法手动充扣，终端按业务规则可能无法使用专项余额。';
      this.$confirm(msg, '提示', { type: 'warning' })
        .then(() => this.applySubsidyStudentStatus(row, newStatus))
        .catch(() => { });
    },
    async applySubsidyStudentStatus(row, newStatus) {
      try {
        const res = await putSubsidyStudentStatus({ Id: row.Id, Status: newStatus });
        if (res.data && res.data.success) {
          row.Status = newStatus;
          this.$message.success(res.data.msg || (newStatus === 1 ? '已启用' : '已停用'));
          return;
        }
        this.$message.error((res.data && res.data.msg) || '保存失败');
      } catch (e) {
        this.$message.error('保存失败');
      }
    },
    openSubsidyHistory(row) {
      this.subsidyHistoryUserId = row.StudentId;
      this.subsidyHistoryPage = 1;
      this.fetchSubsidyHistory();
    },
    fetchSubsidyHistory() {
      getSubsidyAccountChange({
        page: this.subsidyHistoryPage,
        userId: this.subsidyHistoryUserId,
        intPageSize: 10,
      }).then((res) => {
        if (res.data && res.data.success) {
          this.subsidyHistoryTotal = res.data.response.dataCount;
          this.subsidyHistoryData = res.data.response.data;
          this.$nextTick(() => { this.subsidyHistoryVisible = true; });
        }
      });
    },
    subsidyHistoryPageChange(val) {
      this.subsidyHistoryPage = val;
      this.fetchSubsidyHistory();
    },
    subsidyHistoryClose() {
      this.subsidyHistoryData = [];
      this.subsidyHistoryTotal = 0;
      this.subsidyHistoryPage = 1;
    },
    openRecharge(row) {
      this.rechargeRow = row;
      this.rechargeAmount = '';
      this.rechargeType = '1';
      this.selectedReverseId = '';
      this.rechargeDialogVisible = true;
      if (this.subsidyManualReverseEnabled) {
        this.subsidyManualPage = 1;
        this.fetchSubsidyManualList(1);
      }
    },
    fetchSubsidyManualList(page = 1) {
      if (!this.rechargeRow) return;
      this.subsidyManualPage = page;
      getSubsidyManualRechargeList({
        page: this.subsidyManualPage,
        userId: this.rechargeRow.StudentId,
        pageSize: this.subsidyManualPageSize,
      }).then((res) => {
        if (res.data && res.data.success) {
          this.subsidyManualRechargeList = res.data.response.data || [];
          this.subsidyManualTotal = res.data.response.dataCount || 0;
        }
      });
    },
    confirmSubsidyRecharge() {
      if (this.rechargeType !== '3' && (!this.rechargeAmount || isNaN(this.rechargeAmount) || Number(this.rechargeAmount) <= 0)) {
        this.$message.error('请输入有效的金额！');
        return;
      }
      if (this.rechargeType === '3' && !this.selectedReverseId) {
        this.$message.error('请选择要冲正的充值记录！');
        return;
      }
      const opText = this.rechargeType === '1' ? '充值' : this.rechargeType === '2' ? '扣除' : '冲正';
      this.$confirm(`确定要${opText}专项余额吗？`, '提示', { type: 'warning' }).then(async () => {
        this.rechargeLoading = true;
        try {
          let para = {
            StudentUserId: this.rechargeRow.StudentId,
            OpType: Number(this.rechargeType),
          };
          if (this.rechargeType === '3') {
            para.AccountChangeId = this.selectedReverseId;
          } else {
            para.Amount = Number(this.rechargeAmount);
          }
          const res = await manualSubsidyBalance(para);
          if (res.data && res.data.success) {
            this.$message.success(opText + '成功');
            this.rechargeDialogVisible = false;
            this.handleQuery();
          } else {
            this.$message.error((res.data && res.data.msg) || opText + '失败');
          }
        } catch (e) {
          this.$message.error(opText + '失败');
        }
        this.rechargeLoading = false;
      }).catch(() => { });
    },
    async openGroupManage() {
      if (!this.DepartmentId) {
        this.$message.warning('请先在左侧选择部门');
        return;
      }
      this.groupManageVisible = true;
      this.groupManagePage = 1;
      this.newGroupName = '';
      this.newGroupDailyMax = 0;
      await this.refreshGroupManageList();
    },
    async refreshGroupManageList() {
      const res = await getSubsidyStudentGroupList({ departmentId: this.DepartmentId });
      if (res.data && res.data.success)
        this.groupManageList = res.data.response || [];
      const len = (this.groupManageList || []).length;
      const maxPage = Math.max(1, Math.ceil(len / this.groupManagePageSize));
      if (this.groupManagePage > maxPage)
        this.groupManagePage = maxPage;
    },
    async addGroup() {
      if (!this.newGroupName || !this.newGroupName.trim()) {
        this.$message.error('请输入分组名称');
        return;
      }
      const res = await addSubsidyStudentGroup(
        {
          GroupName: this.newGroupName.trim(),
          Sort: 0,
          DailyMaxConsumption: this.newGroupDailyMax != null ? Number(this.newGroupDailyMax) : 0,
        },
        { params: { departmentId: this.DepartmentId } }
      );
      if (res.data && res.data.success) {
        this.$message.success('添加成功');
        this.newGroupName = '';
        await this.refreshGroupManageList();
        this.groupManagePage = Math.max(1, Math.ceil(this.groupManageList.length / this.groupManagePageSize));
        this.loadGroupOptions();
      } else {
        this.$message.error((res.data && res.data.msg) || '添加失败');
      }
    },
    openGroupEdit(row) {
      this.groupEditForm = {
        id: row.Id,
        groupName: row.GroupName || '',
        dailyMaxConsumption: row.DailyMaxConsumption != null ? Number(row.DailyMaxConsumption) : 0,
        sort: row.Sort != null ? row.Sort : 0,
      };
      this.groupEditVisible = true;
    },
    saveGroupEdit() {
      const name = (this.groupEditForm.groupName || '').trim();
      if (!name) {
        this.$message.error('请输入分组名称');
        return;
      }
      this.groupEditLoading = true;
      const dm = this.groupEditForm.dailyMaxConsumption != null ? Number(this.groupEditForm.dailyMaxConsumption) : 0;
      editSubsidyStudentGroup({
        Id: this.groupEditForm.id,
        GroupName: name,
        DailyMaxConsumption: dm < 0 ? 0 : dm,
        Sort: this.groupEditForm.sort != null ? this.groupEditForm.sort : 0,
        Enabled: true,
      }).then((res) => {
        this.groupEditLoading = false;
        if (res.data && res.data.success) {
          this.$message.success(res.data.msg || '保存成功');
          this.groupEditVisible = false;
          this.refreshGroupManageList();
          this.loadGroupOptions();
        } else {
          this.$message.error((res.data && res.data.msg) || '保存失败');
        }
      }).catch(() => { this.groupEditLoading = false; });
    },
    removeGroup(row) {
      this.$confirm('确认删除该分组？已关联学生的分组将需重新设置。', '提示', { type: 'warning' }).then(async () => {
        const res = await deleteSubsidyStudentGroup({ id: row.Id });
        if (res.data && res.data.success) {
          this.$message.success('已删除');
          this.refreshGroupManageList();
          this.loadGroupOptions();
        } else {
          this.$message.error((res.data && res.data.msg) || '删除失败');
        }
      }).catch(() => { });
    },
    openAdminManage() {
      if (!this.DepartmentId) {
        this.$message.warning('请先在左侧选择部门');
        return;
      }
      this.adminManageVisible = true;
      this.adminPage = 1;
      this.clearAdminTeacherPick();
      this.loadAdminList();
    },
    openAdminTeacherPicker() {
      if (!this.DepartmentId) {
        this.$message.warning('请先在左侧选择部门');
        return;
      }
      this.adminTeacherPickerVisible = true;
    },
    clearAdminTeacherPick() {
      this.adminPickTeacherId = null;
      this.adminPickTeacherLabel = '';
    },
    onAdminTeacherPicked(person) {
      if (!person) return;
      this.adminPickTeacherId = person.id;
      this.adminPickTeacherLabel = person.name || '';
    },
    loadAdminList() {
      getSubsidyAccountAdminListPage({
        page: this.adminPage,
        intPageSize: this.adminPageSize,
        departmentId: this.DepartmentId,
      }).then((res) => {
        if (res.data && res.data.success) {
          this.adminTotal = res.data.response.dataCount;
          this.adminList = res.data.response.data || [];
        }
      });
    },
    adminPageChange(val) {
      this.adminPage = val;
      this.loadAdminList();
    },
    async submitAdminAdd() {
      if (!this.adminPickTeacherId) {
        this.$message.warning('请先选择教职工');
        return;
      }
      const res = await addSubsidyAccountAdmin(
        { TeacherId: this.adminPickTeacherId, Name: this.adminPickTeacherLabel || '', Enabled: true },
        { params: { departmentId: this.DepartmentId } }
      );
      if (res.data && res.data.success) {
        this.$message.success('添加成功');
        this.clearAdminTeacherPick();
        this.loadAdminList();
      } else {
        this.$message.error((res.data && res.data.msg) || '添加失败');
      }
    },
    toggleAdmin(row) {
      const willEnable = !row.Enabled;
      const displayName = row.TeacherName || row.Name || '该教师';
      const tip = willEnable
        ? `确定启用「${displayName}」为专项账号管理员吗？`
        : `确定停用「${displayName}」吗？停用后该教师移动端专项相关权限将失效。`;
      this.$confirm(tip, '提示', { type: 'warning' }).then(() => {
        const body = Object.assign({}, row, { Enabled: willEnable });
        editSubsidyAccountAdmin(body).then((res) => {
          if (res.data && res.data.success) {
            this.$message.success(willEnable ? '启用成功' : '停用成功');
            this.loadAdminList();
          } else {
            this.$message.error((res.data && res.data.msg) || (willEnable ? '启用失败' : '停用失败'));
          }
        });
      }).catch(() => { });
    },
    removeAdmin(row) {
      const displayName = row.TeacherName || row.Name || '该管理员';
      this.$confirm(`确定删除「${displayName}」的专项账号管理员配置吗？删除后不可恢复。`, '提示', { type: 'warning' })
        .then(async () => {
          const res = await deleteSubsidyAccountAdmin({ id: row.Id });
          if (res.data && res.data.success) {
            this.$message.success('删除成功');
            this.loadAdminList();
          } else {
            this.$message.error((res.data && res.data.msg) || '删除失败');
          }
        }).catch(() => { });
    },
  },
  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style scoped>
.ps-pick-summary {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  color: #475569;
  font-size: 13px;
}

.ps-pick-tags {
  margin-top: 8px;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.ps-pick-more {
  color: #94a3b8;
  font-size: 12px;
  line-height: 24px;
}

.muted-text {
  color: #94a3b8;
}

/* 禁用按钮仍可触发外层 tooltip（Element 默认禁用时无 hover） */
.subsidy-stu-ops-tip-wrap {
  display: inline-block;
  vertical-align: middle;
}

.admin-op-danger,
.admin-op-danger /deep/ span {
  color: #f56c6c !important;
}

.admin-op-danger:hover,
.admin-op-danger:hover /deep/ span {
  color: #f78989 !important;
}

.admin-op-enable {
  color: #67c23a !important;
}

.admin-op-enable:hover {
  color: #85ce61 !important;
}

/* 专项账号管理员弹窗：选择区一行排布，表头与内容居中 */
.admin-toolbar {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 14px;
}

.admin-toolbar__label {
  flex: none;
  color: #606266;
  font-size: 13px;
  white-space: nowrap;
}

.admin-toolbar__pick {
  flex: 1;
  min-width: 0;
}

.admin-toolbar__select {
  flex: 1;
  min-width: 0;
}

.admin-toolbar__select >>> .el-input {
  width: 100%;
}

.admin-pager {
  margin-top: 12px;
  text-align: right;
}

.admin-pager >>> .el-pagination {
  display: inline-flex;
  justify-content: flex-end;
  flex-wrap: wrap;
}

.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: var(--btn-primary, #2563eb);
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 106.8px;
  height: 106.8px;
  line-height: 106.8px;
  text-align: center;
}

.avatar {
  width: 106.8px;
  height: 106.8px;
  display: block;
}

.avatar-uploader-tip {
  position: absolute;
  width: 100%;
  height: 1vw;
  bottom: 20px;
  color: gray;
  z-index: 99;
}
</style>
